import { NativeService } from "./services/native.service";
import { MenuService, MenuAreaType } from "./services/menu.service";

import { UserService } from "app/services/user.service";
import { Constants } from "./utility/constants";
import { Component, QueryList, ViewChildren, NgZone } from "@angular/core";
import { Platform, MenuController, NavController, ToastController, ModalController, ActionSheetController, PopoverController, IonRouterOutlet, } from "@ionic/angular";


import { Router } from "@angular/router";

import { StorageService } from "app/services/storage.service";

import { VERSION } from "./version";
import { Title } from "@angular/platform-browser";

import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

import { fromEvent, Observable, Subscription } from "rxjs";


import { AppPageGroupModel } from "./models/shared/appPage.model";

import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { NavigationBar, NavigationBarColor } from '@capgo/capacitor-navigation-bar';

import { defineCustomElements } from "@duetds/date-picker/dist/loader";

import { register } from 'swiper/element/bundle';
import { environment } from "environments/environment";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Capacitor } from "@capacitor/core";
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { ThemeService } from "./services/theme.service";

register();

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    standalone: false
})
export class AppComponent
{
    public appPages = [];
    public appPages2 = [];
    public loggedIn: boolean = false;
    public offline: boolean = false;
    public apiError: boolean = false;

    onlineEvent: Observable<Event>;
    offlineEvent: Observable<Event>;

    subscriptions: Subscription[] = [];

    @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

    constructor(
        private platform: Platform,
        // private splashScreen: SplashScreen,
        private storage: StorageService,
        private titleService: Title,
        private router: Router,
        private userService: UserService,
        private screenOrientation: ScreenOrientation,
        private navCtrl: NavController,
        private toastController: ToastController,
        public modalCtrl: ModalController,
        private menu: MenuController,
        private actionSheetCtrl: ActionSheetController,
        private popoverCtrl: PopoverController,
        public menuService: MenuService,
        private modalController: ModalController,
        private zone: NgZone,
        private themeService: ThemeService,
    )
    {
        console.log('Current environment:', environment.buildName);

        // Apply persisted theme ASAP so we avoid a visible flash.
        this.themeService.init();

        defineCustomElements(window);

        this.initializeApp();

        this.onlineEvent = fromEvent(window, "online");
        this.offlineEvent = fromEvent(window, "offline");
        this.setupMenu();
        this.subscriptions.push(
            this.onlineEvent.subscribe((e) =>
            {
                this.userService.ping();
            })
        );

        this.subscriptions.push(
            this.offlineEvent.subscribe((e) =>
            {
                this.userService.ping();
            })
        );

        if (this.platform.is("cordova") && this.platform.is("android"))
        {
            this.backButtonEvent();
        }

        this.menuService.areaSubject.subscribe(async (data) =>
        {
            console.debug(`%carea subject change ${data}`, "color: green");
            this.area = data;
        });

        this.userService.loggedInSubject.subscribe(async (data) =>
        {
            this.loggedIn = data;
            // console.debug(`%cloggedInSubject ${data}`, "color:green");
            if (!this.loggedIn)
            {
                this.area = "dms";
            }
            this.setupMenu();
        });

        this.menuService.embeddedSubject.subscribe(async (data) =>
        {
            // console.debug(`%cembedded subject change ${data}`, "color: green");
            this.embedded = data;
        });

        // Keep theme + native system UI aligned after boot.
        this.themeService.theme$.subscribe(() =>
        {
            // ThemeService already applies CSS + best-effort native nav bar.
        });
        // this.userService.fetchRights();
    }

    platformWidth: number;
    public area: MenuAreaType;
    public embedded: boolean = false;

    ionWillOpen($event)
    {
        // console.log($event);
        // this.setupMenu();
    }

    public subscription: Subscription;
    public appPageGroups: AppPageGroupModel[];
    public menuInitialised: boolean = false;
    async setupMenu()
    {
        this.menuInitialised = false;
        if (!this.appPageGroups || this.appPageGroups.length < 1)
        {
            this.appPageGroups = this.GetDefaultPageGroups();
        }
        setTimeout(async () =>
        {
            if (this.overrideClientID && this.area == "dms")
            {
                this.area = "";
                // this.sendChromeMessage("home", "invalid area loaded");
            }
            var appPageGroups = await this.GetAppPageGroups(this.area);
            this.appPageGroups = appPageGroups;
            if (!this.appPageGroups || appPageGroups.length < 1)
            {
                this.appPageGroups = this.GetDefaultPageGroups();
            }
            appPageGroups = await this.GetAppPageGroups(this.area, true);
            this.appPageGroups = appPageGroups;
            if (!this.appPageGroups || appPageGroups.length < 1)
            {
                this.appPageGroups = this.GetDefaultPageGroups();
            }
        }, 10);
    }

    paused: boolean = false;
    isPaused(): boolean
    {
        return this.paused;
    }

    initializeApp()
    {
        this.platform.ready().then(() =>
        {
            this.setupNative();
            this.appUrlOpen();
            this.appStateChange();
            this.setupFirebase();
            this.setCollapsed();
            this.platform.resize.subscribe(() =>
            {
                this.setCollapsed();
            });

        });
    }



    collapsed: boolean = false;
    private appStateChange()
    {
        App.addListener('appStateChange', ({ isActive }) =>
        {
            if (isActive)
            {
                this.paused = true;
            } else if (this.paused)
            {
                if (this.loggedIn)
                {
                    this.userService.checkClientSideAuthOk();
                }
                this.paused = false;
            }
        });
    }

    private appUrlOpen()
    {
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) =>
        {
            this.zone.run(() =>
            {
                // Example url: https://app.motorcentral.co.nz/vehicles/123
                // slug = /vehicles/123
                // console.log(event.url);
                const slug = event.url.split(".co.nz").pop();
                if (slug)
                {
                    // console.log(slug);
                    this.router.navigateByUrl(slug);
                }
            });
        });
    }

    setCollapsed()
    {
        // this.collapsed = this.platform.width() < this.splitPaneMinWidth;
        this.collapsed = this.platform.height() < this.compactMenuThreshold;
    }


    async setupFirebase()
    {
        //PWA firebase setup
        if (!Capacitor.isNativePlatform())
        {
            // Your web app's Firebase configuration
            // For Firebase JS SDK v7.20.0 and later, measurementId is optional
            const firebaseConfig = {
                apiKey: "AIzaSyAf-ZKK1u7sv0RtkOFh281Ddkt79UpKg0Q",
                authDomain: "app-motorcentral.firebaseapp.com",
                databaseURL: "https://app-motorcentral.firebaseio.com",
                projectId: "app-motorcentral",
                storageBucket: "app-motorcentral.firebasestorage.app",
                messagingSenderId: "942085772024",
                appId: "1:942085772024:web:56e6781ba6eeffde35210d",
                measurementId: "G-6EXF0KXBNM"
            };

            FirebaseAnalytics.initializeFirebase(firebaseConfig);

            this.router.events.subscribe(async (event) =>
            {
                // Only act on NavigationEnd events
                if (event.constructor.name === "NavigationEnd")
                {
                    // Find the activated route
                    let route = this.router.routerState.root;
                    while (route.firstChild)
                    {
                        route = route.firstChild;
                    }
                    // Get the component name if available
                    const component = route.routeConfig && route.routeConfig.component;
                    let title = "Unknown";
                    if (component && component.name)
                    {
                        title = component.name;
                    }
                    console.log(`Setting Firebase Analytics screen: ${title}`);
                    await FirebaseAnalytics.setScreenName({ screenName: title, nameOverride: title });
                }
            });
        }
    }

    ngOnInit()
    {
        this.loggedIn =
            localStorage.getItem(Constants.LocalStorage_LoggedIn) == "1";

        this.userService.loggedInSubject.next(this.loggedIn);

        this.overrideClientID = localStorage.getItem(
            Constants.LocalStorage_OverrideClientID
        );
        if (this.overrideClientID)
        {
            this.splitPaneMinWidth = 800;
        }

        this.setupMenu();

        this.setTitle("Motorcentral");
        this.enableMenus();
        this.initialiseFirebaseMessagingForPwa();
    }

    async enableMenus()
    {
        await this.menu.enable(true, "first");
    }

    ngAfterViewInit()
    {
        this.loggedIn = localStorage.getItem(Constants.LocalStorage_LoggedIn) == "1";
    }

    version = VERSION.version;
    initials: string;
    nameOfUser: string;
    notifications: number;
    year: string = new Date().getFullYear().toString();

    public checkActivePage(page): boolean
    {
        // console.log(Router);
        return true; //return page === this.activePage;
    }

    public async setupNative()
    {
        try
        {
            SplashScreen.hide();
            // // Show the splash for two seconds and then auto hide:
            // SplashScreen.show({
            // 	showDuration: 500,
            // 	autoHide: true
            // });

            if (this.platform.is("hybrid"))
            {
                this.platform.ready().then(() =>
                {
                    this.screenOrientation.lock(
                        this.screenOrientation.ORIENTATIONS.PORTRAIT
                    );
                });
            }

            if (this.platform.is("hybrid"))
            {
                if (this.platform.is("android"))
                {
                    const isAndroid16Plus = await this.userService.nativeService.devicePlatformMinVersion(16);
                    if (isAndroid16Plus)
                    {
                        // Android 15+/16+ enforces edge-to-edge; make the status bar area part of the app UI.
                        // We read the current inset (when available) and use it to pad the header, then let the webview
                        // extend to the top so the header background is visible behind the status bar.
                        try
                        {
                            const insets = await EdgeToEdge.getInsets();
                            const topInset = (insets as any)?.top;
                            const bottomInset = (insets as any)?.bottom;
                            if (typeof topInset === 'number')
                            {
                                document.documentElement.style.setProperty('--mc-statusbar-height', `${topInset}px`);
                            }

                            // Gestures typically report 0 bottom inset; 3-button navigation reports a non-zero inset.
                            // We apply a small hardcoded padding only when 3-button nav is detected.
                            const hasNavButtons = typeof bottomInset === 'number' && bottomInset > 10;
                            document.documentElement.classList.toggle('mc-android-nav-buttons', hasNavButtons);
                            document.documentElement.classList.add('mc-android-edge-to-edge');
                        }
                        catch { }

                        try { await EdgeToEdge.disable(); } catch { }
                        try { await StatusBar.setOverlaysWebView({ overlay: true }); } catch { }

                        // Make the system navigation bar transparent, with dark buttons/icons.
                        try
                        {
                            await NavigationBar.setNavigationBarColor({
                                color: NavigationBarColor.TRANSPARENT,
                                darkButtons: true,
                            });
                        }
                        catch { }

                        await this.userService.nativeService.setupStatusBar();
                    }
                    else
                    {
                        await EdgeToEdge.setBackgroundColor({
                            color: '#000000'
                        });
                        await StatusBar.setOverlaysWebView({
                            overlay: false
                        });
                        await StatusBar.setBackgroundColor({
                            color: Constants.StatusBarColor_Dark,
                        });
                        await StatusBar.setStyle({
                            style: Style.Dark,
                        });
                    }
                }
                else
                {
                    await StatusBar.setStyle({
                        style: Style.Light,
                    });
                }
            }
        } catch (error) { }
    }

    trackByFn(index: number, item: any): string | number
    {
        if (!item)
        {
            return index;
        }

        // AppPageGroupModel: tracking by `area` alone can create duplicates (e.g. multiple "wholesale" groups).
        // Build a composite key and include index to guarantee uniqueness.
        if (Array.isArray(item.pages))
        {
            const area = item.area ?? "";
            const name = item.name ?? "";
            const pagesKey = item.pages
                .map((p: any) => p?.url ?? p?.title ?? "")
                .filter((v: any) => typeof v === "string" && v.length > 0)
                .join(",");

            const groupKey = [String(area), String(name), pagesKey].filter((v) => v.length > 0).join("|");
            return groupKey.length > 0 ? `${groupKey}|${index}` : index;
        }

        // AppPageModel (or other items): prefer stable identifiers.
        const key = item.id ?? item.url ?? item.name ?? item.title ?? item.area;
        if (key === undefined || key === null || key === "")
        {
            return index;
        }

        return key;
    }

    isDesktop(): boolean
    {
        return this.platform.width() >= this.splitPaneMinWidth;
    }

    public setTitle(newTitle: string)
    {
        this.titleService.setTitle(newTitle);
    }

    public loadLink(url: string)
    {
        this.router.navigate([url]);
        this.menu.close();
    }

    getContactColourClass(name: string = ""): string
    {
        let initial = "";
        let className = "";
        let checkName = name ? name : "";

        if (checkName.length > 0)
        {
            initial = checkName[0].toLowerCase();
        }

        if (!/^[a-z]$/.test(initial))
        {
            initial = "";
        }

        if (initial === "")
        {
            initial = "0";
        }

        return "contactbadge contact-class-" + initial;
    }

    async logout()
    {
        this.menu.close();
        this.userService.confirmLogout();
    }

    async menuclick()
    {
        if (this.menu.isOpen())
        {
            this.menu.close();
        }
    }

    splashCount: number = 0;
    async doSplash()
    {
        this.splashCount++;
        if (this.splashCount > 1)
        {
            this.splashCount = 0;
            this.menu.close();
            this.navCtrl.navigateRoot("/splash");
        }
    }

    async dealerServices()
    {
        if (this.loggedIn)
        {
            this.menu.close();
            this.navCtrl.navigateRoot("/dealer-services");
        }
    }

    public ngOnDestroy()
    {
        if (this.subscription)
        {
            this.subscription.unsubscribe();
        }
    }

    async reload()
    {
        location.reload();
    }

    async showToast(message: string, color: string)
    {
        const toast = await this.toastController.create({
            message: message,
            duration: 3000,
            position: "bottom",
            animated: true,
            color: color,
            translucent: true,
        });
        toast.present();
    }

    //solution from https://forum.ionicframework.com/t/hardware-back-button-with-ionic-4/137905/27
    async backButtonEvent()
    {
        App.addListener("backButton", async () =>
        {
            // close action sheet
            try
            {
                const element = await this.actionSheetCtrl.getTop();
                if (element)
                {
                    element.dismiss();
                    return;
                }
            } catch (error) { }

            // close popover
            try
            {
                const element = await this.popoverCtrl.getTop();
                if (element)
                {
                    element.dismiss();
                    return;
                }
            } catch (error) { }

            // close modal
            try
            {
                const element = await this.modalCtrl.getTop();
                if (element)
                {
                    element.dismiss();
                    return;
                }
            } catch (error)
            {
                console.error(error);
            }

            // close side menua
            try
            {
                const element = await this.menu.isOpen();
                // console.log(element);
                if (element)
                {
                    this.menu.close();
                    return;
                }
            } catch (error) { }

            var root_page = [
                "/opportunities",
                "/contacts",
                "/sales",
                "/exports",
                "/reports",
                "/help",
                "/dealer-services",
                "/notifications",
                "/wholesale",
                "/finance",
                "/carcheck",
                "/autoattendant",
                "/buyerscore",
                "/user",
                "/barcode",
                "/dashboard",
                "/tools",
            ];
            // console.log(root_page.includes(this.router.url));
            if (root_page.includes(this.router.url))
            {
                // console.log("navigate to root of app");
                this.navCtrl.navigateRoot("/vehicles");
                return;
            }

            if (this.router.url == "/vehicles" || this.router.url == "/login")
            {
                App.exitApp();
            }
        });
    }

    lastTimeBackPress = 0;
    timePeriodToExit = 2000;
    public overrideClientID: string = "";
    splitPaneMinWidth: number = 1281;
    compactMenuThreshold: number = 650;

    public async GetAppPageGroups(
        area: MenuAreaType,
        fetchExtendedRights: boolean = false
    ): Promise<AppPageGroupModel[]>
    {
        if (!this.loggedIn)
        {
            return this.GetDefaultPageGroups();
        }
        else
        {
            this.menuInitialised = true;

            const rights = await this.userService.getCachedRights().toPromise();

            if (!fetchExtendedRights)
            {
                return this.menuService.GetAppPageGroups(area, rights, []);
            }
            else
            {
                const extendedRights = await this.userService
                    .getCachedExtendedRights()
                    .toPromise();
                return this.menuService.GetAppPageGroups(area, rights, extendedRights);
            }
        }
    }

    public GetDefaultPageGroups(): AppPageGroupModel[]
    {
        var appPageGroups: AppPageGroupModel[] = [];
        appPageGroups.push({
            name: "",
            area: "dms",
            pages: [
                {
                    title: "Login",
                    url: "/login",
                    iconalt: "icon-mc-login",
                },
            ],
        });

        this.menuInitialised = true;
        return appPageGroups;
    }

    async goBack()
    {
        // this.menuclick();
        var location: string;
        switch (this.menuService.previousArea)
        {
            case "dms":
                location = "vehicles";
                break;
            case "wholesale":
                location = "wholesale/vehicles";
                break;
            default:
                location = this.menuService.previousArea;
        }
        this.navCtrl.navigateRoot("/" + location);
    }

    sendChromeMessage(action, data)
    {
        var msgObject = {
            action: action,
            data: data,
        };
        var json = JSON.stringify(msgObject);
        try
        {
            console.error(msgObject);
            (window as any).chrome.webview.postMessage(json);
        } catch
        {
            //we're not in a webview
        }
    }

    scrollTop: boolean = true;
    ionScrollEvent(ev: any)
    {
        var scrollTop = ev.detail.scrollTop == 0;
        if (this.scrollTop != scrollTop)
        {
            this.scrollTop = scrollTop;
        }
    }

    async areaSelected()
    {
        this.modalController.dismiss({
            dismissed: true,
        });
        this.menuclick();
    }

    async appmenuclick()
    {

    }

    async initialiseFirebaseMessagingForPwa()
    {
        if (Capacitor.isNativePlatform())
        {
            return;
        }

        // Initialize Firebase
        const firebaseConfig = environment.pwaFirebase;
        if (firebaseConfig)
        {
            const app = initializeApp(firebaseConfig);
            console.debug("Firebase initialized for PWA");
        }
    }
}
